export default __webpack_public_path__ + "5518dc9327185ff0e08c5847bf99e351.svg";